// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"b967a040","836":"bb370a18","960":"7d32a387"}[chunkId] + ".css";
};